import { gql } from '@apollo/client';

const GET_AGENT_AVAILABILITY = gql`
  query getAgentAvailability($timeZone: String!) {
    getAgentAvailability(timeZone: $timeZone) {
      agents {
        firstName
        lastName
        agentProfile {
          user_id
          scheduling_system_slug
        }
        availabilityTag
      }
    }
  }
`;

export default GET_AGENT_AVAILABILITY;
